/**
 * Global hotkeys & clipboard integration for the board page.
 * Supports copy/paste (elements/text/image), undo/redo, and zoom in/out.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect } from 'react';
const PREFIX = 'BATTLEBOARD_ELEMENTS:';
/**
 * Проверяет, находится ли фокус в поле ввода (input, textarea или contentEditable элемент)
 */
function isInputFocused() {
    const activeElement = document.activeElement;
    return (activeElement !== null &&
        (activeElement.tagName === 'INPUT' ||
            activeElement.tagName === 'TEXTAREA' ||
            activeElement.contentEditable === 'true'));
}
export function useHotkeys(h) {
    useEffect(() => {
        function onKey(e) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
                // Если фокус в поле ввода, не обрабатываем горячие клавиши
                if (isInputFocused())
                    return;
                const ctrl = e.ctrlKey || e.metaKey;
                const keyCode = e.code;
                /* [CTRL] modifier key */
                if (ctrl && keyCode === 'KeyC') {
                    e.preventDefault();
                    (_a = h.onCopy) === null || _a === void 0 ? void 0 : _a.call(h);
                }
                if (ctrl && keyCode === 'KeyV') {
                    // e.preventDefault();
                    // await handlePaste();
                }
                if (ctrl && keyCode === 'KeyZ') {
                    e.preventDefault();
                    (_b = h.onUndo) === null || _b === void 0 ? void 0 : _b.call(h);
                }
                if (ctrl && (keyCode === 'KeyY' || (e.shiftKey && keyCode === 'KeyZ'))) {
                    e.preventDefault();
                    (_c = h.onRedo) === null || _c === void 0 ? void 0 : _c.call(h);
                }
                if (ctrl && keyCode === 'Equal') {
                    e.preventDefault();
                    (_d = h.onZoomIn) === null || _d === void 0 ? void 0 : _d.call(h);
                }
                if (ctrl && keyCode === 'Minus') {
                    e.preventDefault();
                    (_e = h.onZoomOut) === null || _e === void 0 ? void 0 : _e.call(h);
                }
                // [No modifier keys]
                if (keyCode === 'BracketRight') {
                    e.preventDefault();
                    (_f = h.onZIndexUp) === null || _f === void 0 ? void 0 : _f.call(h);
                }
                if (keyCode === 'BracketLeft') {
                    e.preventDefault();
                    (_g = h.onZIndexDown) === null || _g === void 0 ? void 0 : _g.call(h);
                }
                if (keyCode === 'Delete' || keyCode === 'Backspace') {
                    e.preventDefault();
                    (_h = h.onDelete) === null || _h === void 0 ? void 0 : _h.call(h);
                }
                if (keyCode === 'Escape' || keyCode === 'Esc') {
                    e.preventDefault();
                    (_j = h.onEscape) === null || _j === void 0 ? void 0 : _j.call(h);
                }
                if (keyCode === 'ArrowUp') {
                    e.preventDefault();
                    (_k = h.onArrowUp) === null || _k === void 0 ? void 0 : _k.call(h);
                }
                if (keyCode === 'ArrowDown') {
                    e.preventDefault();
                    (_l = h.onArrowDown) === null || _l === void 0 ? void 0 : _l.call(h);
                }
                if (keyCode === 'ArrowLeft') {
                    e.preventDefault();
                    (_m = h.onArrowLeft) === null || _m === void 0 ? void 0 : _m.call(h);
                }
                if (keyCode === 'ArrowRight') {
                    e.preventDefault();
                    (_o = h.onArrowRight) === null || _o === void 0 ? void 0 : _o.call(h);
                }
                if (keyCode === 'KeyL') {
                    e.preventDefault();
                    (_p = h.onToggleLock) === null || _p === void 0 ? void 0 : _p.call(h);
                }
                if (ctrl && keyCode === 'KeyG' && !e.shiftKey) {
                    e.preventDefault();
                    (_q = h.onGroup) === null || _q === void 0 ? void 0 : _q.call(h);
                }
                if (ctrl && keyCode === 'KeyG' && e.shiftKey) {
                    e.preventDefault();
                    (_r = h.onUngroup) === null || _r === void 0 ? void 0 : _r.call(h);
                }
            });
        }
        function handlePaste() {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                // Попытка через Clipboard API (для изображений из браузера)
                try {
                    const items = yield navigator.clipboard.read();
                    const imageFiles = [];
                    for (const item of items) {
                        for (const type of item.types) {
                            if (type.startsWith('image/')) {
                                const blob = yield item.getType(type);
                                const file = new File([blob], `pasted.${type.split('/')[1]}`);
                                imageFiles.push(file);
                            }
                        }
                    }
                    if (imageFiles.length > 0) {
                        // Если несколько изображений, используем onPasteImages, иначе onPasteImage
                        if (imageFiles.length > 1 && h.onPasteImages) {
                            h.onPasteImages(imageFiles);
                        }
                        else {
                            (_a = h.onPasteImage) === null || _a === void 0 ? void 0 : _a.call(h, imageFiles[0]);
                        }
                        return;
                    }
                }
                catch (_d) {
                    /* ignore */
                }
                // Fallback: текст или сериализованные элементы
                try {
                    const text = yield navigator.clipboard.readText();
                    if (text === null || text === void 0 ? void 0 : text.startsWith(PREFIX)) {
                        const json = text.slice(PREFIX.length);
                        const payload = JSON.parse(json);
                        (_b = h.onPasteElements) === null || _b === void 0 ? void 0 : _b.call(h, payload);
                        return;
                    }
                    if (text)
                        (_c = h.onPasteText) === null || _c === void 0 ? void 0 : _c.call(h, text);
                }
                catch (_e) {
                    /* ignore */
                }
            });
        }
        // Обработчик paste события (синхронный для файлов, асинхронный для fallback)
        function onPaste(e) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                // Если фокус в поле ввода, не обрабатываем вставку (позволяем стандартное поведение)
                if (isInputFocused())
                    return;
                e.preventDefault();
                // Сначала проверяем файлы (для изображений из файловой системы)
                const files = (_a = e.clipboardData) === null || _a === void 0 ? void 0 : _a.files;
                if (files && files.length > 0) {
                    const imageFiles = Array.from(files).filter((file) => file.type.startsWith('image/'));
                    if (imageFiles.length > 0) {
                        // Если несколько изображений, используем onPasteImages, иначе onPasteImage
                        if (imageFiles.length > 1 && h.onPasteImages) {
                            h.onPasteImages(imageFiles);
                        }
                        else {
                            (_b = h.onPasteImage) === null || _b === void 0 ? void 0 : _b.call(h, imageFiles[0]);
                        }
                        return;
                    }
                }
                // Если файлов нет, используем handlePaste для Clipboard API и текста
                yield handlePaste();
            });
        }
        window.addEventListener('keydown', onKey);
        window.addEventListener('paste', onPaste);
        return () => {
            window.removeEventListener('keydown', onKey);
            window.removeEventListener('paste', onPaste);
        };
    }, [h]);
}
export function serializeSelection(payload) {
    return PREFIX + JSON.stringify(payload);
}
